<template>

  <v-card class="d-flex flex-column align-center justify-center">
    <!-- Title -->
    <v-card-title class="text-h5" v-if="title">
      {{ titleText }}
    </v-card-title>

    <!-- Canvas pad -->
    <div class="text-xs-center">
      <canvas id="signature-pad" ref="sigPad"></canvas>
    </div>

    <!-- Actions -->
    <v-card-actions class="ma-0 pa-0 signature-actions-area">
      <v-toolbar flat width="300">
        <v-btn text v-if="showCancel && !isUploading" @click="cancel">Cancel</v-btn>
        <v-btn
            text
            class="ml-4"
            v-if="showClear && !isUploading"
            @click="clear">
          Clear
        </v-btn>
        <v-spacer />
        <v-btn
            color="primary"
            width="100"
            @click="save">
          <span v-if="isUploading"><v-progress-circular indeterminate :size="12" color="white" /></span>
          <span v-else>Save</span>
        </v-btn>
      </v-toolbar>
    </v-card-actions>
  </v-card>

</template>

<script>
import SignaturePad from 'signature_pad'

export default {
  name: 'UserSignature',

  props: {
    title: {
      type: String,
      required: false
    },
    assetKey: {
      type: String,
      required: true
    },
    enableUpload: {
      type: Boolean,
      default: true
    },
    showClear: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      sigPad: null,
      imageData: null,
      isUploading: false
    }
  },

  computed: {
    titleText () {
      return this.title || ''
    }
  },

  mounted () {
    this.sigPad = new SignaturePad(this.$refs.sigPad, {
      backgroundColor: 'white',
      penColor: 'rgb(0,0,0)'
    })
  },

  beforeDestroy () {
    this.clear()
  },

  methods: {
    clear () {
      this.sigPad.clear()
      this.imageData = null
    },

    cancel () {
      this.clear()
      this.$emit('canceled')
    },

    async save () {
      let uploaded = false
      this.imageData = this.sigPad.toDataURL('image/svg+xml')

      // Perform upload, if enabled
      if (this.enableUpload) {
        this.isUploading = true
        try {
          await this.uploadAsset()
          uploaded = true
        } catch (err) {
          console.log('Error uploading asset =>', err)
        }
        this.isUploading = false
      }

      // Emit results
      this.$emit('saved', {
        asset_key: this.assetKey,
        image_data: this.imageData,
        uploaded
      })

      this.clear()
    },

    async uploadAsset () {
      const assetKey = this.assetKey
      const imageData = this.imageData
      if (!assetKey || !imageData) return false

      let uploadInfo = null
      try {
        const file = this.$root.utils.imageDataToFile(imageData)

        // Generate upload URL
        uploadInfo = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: 'my/user/asset/uploadUrl',
          opts: {
            params: { asset_key: assetKey }
          },
          to_model: false
        })

        // Upload document
        await fetch(uploadInfo.url, { method: 'PUT', body: file })
      } catch (err) {
        console.log(`Error generating upload info for asset: ${assetKey} =>`, err)
        throw err
      }
    }
  }
}
</script>

<style>
  .signature-actions-area .theme--dark.v-toolbar.v-sheet .v-toolbar__content {
    background-color: #1e1e1e;
    margin: 0 !important;
    padding: 0 !important;
  }

  .signature-pad {
    width: 300px;
    height: 100px;
  }
</style>
